import {
  CellWrapper,
  DisabledTag
} from '@nile/mangifera/src/Pebbles/TicketContainer';
import TicketInfoPopup from './TicketInfoPopup';
import { Link, Tippy } from '@superops/ui-design-system';
import React from 'react';
import dompurify from 'dompurify';
import { Tooltip } from 'react-clone-tippy';
import styled from 'styled-components';
import {
  UnknownTicketActions,
  useProduct,
  COMMON_CONSTANTS
} from '@nile/components';
import { SVGIcon } from '@superops/super-icons';

function SubjectCell(props) {
  const { cell, action } = props;
  const { editable } = cell.column;
  const isITProduct = useProduct(COMMON_CONSTANTS.IT);
  const actions = cell.column.actions;
  const ticket = cell?.row?.original;
  const isTriageTicket = ticket?.technician?.userId === '14';
  const value = props.column.subAccessor
    ? cell.value[props.column.subAccessor]
    : cell.value;
  const allProps = {
    ...cell,
    ticketId: cell.row.original.ticketId,
    module: 'TICKET',
    data: {
      subject: cell?.row?.original?.subject,
      displayId: cell?.row?.original?.displayId,
      ticketId: cell?.row?.original?.ticketId
    },
    unknownTicket: ticket.client === null
  };
  const isUnknownTicket = ticket.client === null || ticket.site === null;
  /* revisit dangerouslySetInnerHTML xss  */
  return value ? (
    <>
      <div className="d-in position-relative w100 mw-100">
        <div className="w100" id={value} key={value}>
          {cell?.column?.isTrashView ? (
            <div className="subject ellipsis">{value}</div>
          ) : (
            <div className="fx actr full-width">
              <div className={` ${isUnknownTicket ? 'mcw-80' : 'mw-100'}`}>
                <TicketInfoPopup
                  activator={
                    (isITProduct ? (
                      ticket.site === null
                    ) : (
                      ticket.client === null
                    )) ? (
                      <div className="subject ellipsis">{value}</div>
                    ) : (
                      <Link
                        onClick={actions.onClick.bind(this, allProps)}
                        removeUnderline
                      >
                        <div className="subject ellipsis">{value}</div>
                      </Link>
                    )
                  }
                  data={allProps}
                />
              </div>
              {editable &&
                (isITProduct
                  ? ticket.site === null
                  : ticket.client === null) && (
                  <div className="fx actr mlauto">
                    <UnknownTicketActions
                      ticket={ticket}
                      associationSuccess={() => actions.refreshTable()}
                      deletionSuccess={() => actions.refreshTable()}
                    />
                  </div>
                )}
            </div>
          )}
        </div>
      </div>
    </>
  ) : (
    <>
      <DisabledTag>NA</DisabledTag>
    </>
  );
}

export default React.memo(SubjectCell);
